import React, { useState } from "react";
import DataTable from "react-data-table-component";
import Select from "react-select";
import Swal from "sweetalert2";
import {
  Button,
  Card,
  Form,
  Container,
  Row,
  Col,
  Tab,
  Modal,
  InputGroup,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";
import moment from "moment";
import { ColorRing, Dna, Watch } from "react-loader-spinner";
import { useDispatch, useSelector } from "react-redux";
import ReactPaginate from "react-paginate";
import { getAllKunjunganByLogin } from "stores/kunjungan/function";
import { updateApprovalKunjungan } from "stores";
import GoogleMapReact from "google-map-react";
import { exportPdfKunjungan } from "stores";
import { editFotoKunjungan } from "stores";
import { ajukanRevisiKunjungan } from "stores";
import { getExportKunjungan } from "stores";
import { showUrlDokumenKunjungan } from "stores";

function ListKunjungan() {
  const dispatch = useDispatch();
  const kunjungan = useSelector((state) => state.kunjunganReducer);
  const Korcab = useSelector((state) => state.korcabReducer);
  const auth = useSelector((state) => state.authReducer);
  const urlPreview = Korcab.urlDokumenKunjungan;
  const [listDataKunjungan, setListDataKunjungan] = React.useState([]);
  const [modalDetail, setModalDetail] = React.useState(false);
  const [modalRevisi, setModalRevisi] = React.useState(false);
  const [keterangan, setKeterangan] = React.useState("");
  const [namaNasabah, setNamaNasabah] = React.useState("");
  const [modalEditFoto, setModalEditFoto] = React.useState(false);
  const [isLoading, setIsLoading] = React.useState(true);
  const [totalPerHalaman, setTotalPerHalaman] = React.useState(10);
  const [page, setPage] = React.useState(0);
  const [buktiKunjungan, setBuktiKunjungan] = React.useState("");
  const [tampilFotoKunjungan, setTampilFotoKunjungan] = React.useState("");
  const [kirimFotoKunjungan, setKirimFotoKunjungan] = React.useState("");
  const [urlFoto, setUrlFoto] = React.useState("");
  const [idKunjungan, setIdKunjungan] = React.useState("");
  const [latitude, setLatitude] = useState(null);
  const [longitude, setLongitude] = useState(null);
  const [filterStatus, setFilterStatus] = React.useState(null);
  const [pilihOpsi, setPilihOpsi] = React.useState("");
  const [listStatus, setListStatus] = React.useState([]);
  const [searchText, setSearchText] = React.useState("");
  const [showUploadForm, setShowUploadForm] = React.useState(false);
  const [modalExport, setModalExport] = React.useState(false);
  const [tglAwal, setTglAwal] = React.useState("");
  const [tglAkhir, setTglAkhir] = React.useState("");
  const [selectedKeterangan, setSelectedKeterangan] = React.useState(null);
  const [loading, setLoading] = React.useState(false);
  const [loadingEditFoto, setLoadingEditFoto] = React.useState(false);
  const [modalKeteranganVisible, setModalKeteranganVisible] =
    React.useState(false);

  const handleKeteranganClick = (keterangan) => {
    setSelectedKeterangan(keterangan);
    setModalKeteranganVisible(true);
  };

  const handlePageSizeChange = (selectedOption) => {
    setTotalPerHalaman(selectedOption.value);
  };

  const handleAnimationComplete = () => {
    console.log("All letters have animated!");
  };

  const handleClick = (val) => {
    setModalDetail(!modalDetail);
    setLoading(true); // Mulai loading
    setTimeout(() => {
      setLoading(false);
    }, 2000);
    setBuktiKunjungan(
      showUrlDokumenKunjungan(dispatch, {
        urlImage: val.buktiKunjungan,
      }),
    );
    setLatitude(parseFloat(val.lat));
    setLongitude(parseFloat(val.long));
  };

  const handleClickEditFoto = (val) => {
    setModalEditFoto(!modalEditFoto);
    setLoadingEditFoto(true); // Mulai loading
    setTimeout(() => {
      setLoadingEditFoto(false);
    }, 2000);
    setTampilFotoKunjungan(
      showUrlDokumenKunjungan(dispatch, {
        urlImage: val.buktiKunjungan,
      }),
    );
    setIdKunjungan(val._id);
    setUrlFoto(val.buktiKunjungan);
  };

  const handleFilterChange = () => {
    setIsLoading(true);
    getAllKunjunganByLogin(dispatch, {
      page: page + 1,
      limit: totalPerHalaman,
      cari: searchText,
    })
      .then((response) => {
        setIsLoading(false); // Setelah selesai memuat data
      })
      .catch((error) => {
        setIsLoading(false); // Jika terjadi error
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Terjadi kesalahan saat memuat data.",
        });
      });
  };

  const submitAjukanRevisiKunjungan = () => {
    if (keterangan === "") {
      Swal.fire({
        title: "Keterangan Wajib Diisi",
        icon: "warning",
      });
      return;
    }

    Swal.fire({
      title: "Yakin ingin mengajukan revisi?",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Ajukan",
      cancelButtonText: "Batal",
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.fire({
          title: "Loading...",
          allowOutsideClick: false,
          showConfirmButton: false,
          onBeforeOpen: () => {
            Swal.showLoading();
          },
        });

        ajukanRevisiKunjungan({
          idKunjungan: idKunjungan,
          keterangan: keterangan,
        })
          .then((response) => {
            if (response.data.status === 200) {
              Swal.fire({
                position: "center",
                icon: "success",
                title: response.data.message,
                showConfirmButton: false,
                timer: 1000,
              });
              handleCloseModal();
              setModalRevisi(false);
              getAllKunjunganByLogin(dispatch, {
                page: page + 1,
                limit: totalPerHalaman,
                cari: searchText,
              });
            } else if (response.data.status === 400) {
              Swal.fire({
                icon: "error",
                title: "Oops...",
                text: response.data.message,
              });
            }
          })
          .catch((error) => {
            console.log("ERRORRRR", error);
            Swal.fire({
              icon: "error",
              title: "Terjadi kesalahan!",
              text: "Silakan coba lagi nanti.",
            });
          });
      }
    });
  };

  const submitExport = (e) => {
    e.preventDefault();
    // console.log(tglAwal, tglAkhir, status.value, "ASLKASDASDSAD");
    // if (status === "") {
    //   Swal.fire({
    //     title: "Status Harus Diisi",
    //     icon: "warning",
    //   });
    //   return;
    // }
    getExportKunjungan({
      tglAwal: tglAwal,
      tglAkhir: tglAkhir,
    });
  };

  // const submitAjukanRevisiKunjungan = () => {
  //   if (keterangan == "") {
  //     Swal.fire({
  //       title: "Keterangan Wajib Diisi",
  //       icon: "warning",
  //     });
  //     return;
  //   }
  //   ajukanRevisiKunjungan({
  //     idKunjungan: idKunjungan,
  //     keterangan: keterangan,
  //   })
  //     .then((response) => {
  //       if (response.data.status === 200) {
  //         Swal.fire({
  //           position: "center",
  //           icon: "success",
  //           title: response.data.message,
  //           showConfirmButton: false,
  //           timer: 1000,
  //         });
  //         handleCloseModal();
  //         setModalRevisi(false);
  //         getAllKunjunganByLogin(dispatch, {
  //           page: page + 1,
  //           limit: totalPerHalaman,
  //           cari: searchText,
  //         });
  //       } else if (response.data.status === 400) {
  //         Swal.fire({
  //           icon: "error",
  //           title: "Oops...",
  //           text: response.data.message,
  //         });
  //       }
  //     })
  //     .catch((error) => {
  //       console.log("ERRORRRR", error);
  //     });
  // };

  const handleExportPengajuan = () => {
    setTglAwal("");
    setTglAkhir("");
  };

  function submitEditFoto(e) {
    e.preventDefault();
    if (kirimFotoKunjungan === "") {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Foto tidak boleh kosong !",
      });
      return;
    }
    Swal.fire({
      title: "Konfirmasi",
      text: "Apakah Anda yakin ingin menyimpan perubahan?",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Ya",
      cancelButtonText: "Tidak",
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.fire({
          title: "Loading...",
          allowOutsideClick: false,
          showConfirmButton: false,
          onBeforeOpen: () => {
            Swal.showLoading();
          },
        });
        let dataToSend = new FormData();
        dataToSend.append("idKunjungan", idKunjungan);
        dataToSend.append("urlFoto", urlFoto);
        dataToSend.append("buktiKunjungan", kirimFotoKunjungan);

        editFotoKunjungan(dataToSend)
          .then((response) => {
            // console.log(response, "HHH");
            if (response.status === 200) {
              Swal.close();
              Swal.fire({
                position: "center",
                icon: "success",
                title: response.data.message,
                showConfirmButton: false,
                timer: 1500,
              });
              setModalEditFoto(false);

              // window.location.reload();
            } else if (response.status === 400) {
              Swal.fire({
                icon: "error",
                title: "Oops...",
                text: response.data.message,
              });
            }
          })
          .catch((error) => {
            console.error(error);
          });
      }
    });
  }

  React.useEffect(() => {
    if (kunjungan.dataKunjungan.docs) {
      let tmp = kunjungan.dataKunjungan.docs.map((val) => {
        // Logic disable tetap sama (tidak merubah fungsi)
        const isDisabled =
          val.statusRevisi === true ||
          (auth.role === "client" &&
            (!val.approvalSupervisor || val.approvalKacap === true)) ||
          (auth.role === "supervisor" && val.approvalSupervisor) ||
          val.keputusan === "Ditolak";

        const isRevisiDisabled =
          (auth.role === "supervisor" &&
            (val.statusRevisi === true || val.approvalSupervisor === true)) ||
          (auth.role === "client" &&
            auth.jabatan === "korcab" &&
            val.approvalSupervisor === false) ||
          val.statusRevisi === true;

        return {
          ...val,
          action: (
            <div
              className="d-flex justify-content-center align-items-center flex-nowrap"
              style={{ gap: "6px" }}
            >
              {/* 1. TOMBOL DETAIL */}
              <OverlayTrigger
                placement="top"
                overlay={<Tooltip id={`t-detail-${val._id}`}>Detail</Tooltip>}
              >
                <Button
                  className="btn-icon d-flex align-items-center justify-content-center shadow-sm"
                  style={{
                    width: "32px",
                    height: "32px",
                    borderRadius: "8px",
                    backgroundColor: "#E0F2FE",
                    border: "1px solid #BAE6FD",
                    color: "#0369A1",
                  }}
                  onClick={() => handleClick(val)}
                >
                  <i className="fas fa-eye" style={{ fontSize: "13px" }}></i>
                </Button>
              </OverlayTrigger>

              {/* 2. TOMBOL APPROVAL */}
              {((auth.role === "client" && auth.jabatan === "korcab") ||
                auth.role === "super admin" ||
                auth.role === "supervisor") && (
                <OverlayTrigger
                  placement="top"
                  overlay={<Tooltip id={`t-app-${val._id}`}>Approval</Tooltip>}
                >
                  <Button
                    className="btn-icon d-flex align-items-center justify-content-center shadow-sm"
                    disabled={isDisabled}
                    style={{
                      width: "32px",
                      height: "32px",
                      borderRadius: "8px",
                      backgroundColor: isDisabled ? "#F1F5F9" : "#DCFCE7",
                      border: isDisabled
                        ? "1px solid #E2E8F0"
                        : "1px solid #BBF7D0",
                      color: isDisabled ? "#94A3B8" : "#15803D",
                      cursor: isDisabled ? "not-allowed" : "pointer",
                    }}
                    onClick={async () => {
                      // Logic Swal kamu tetap sama di sini...
                      const result = await Swal.fire({
                        title: "Approve Kunjungan",
                        text: `Apakah anda yakin menyetujui ${val.calonNasabah.namaNasabah} ?`,
                        icon: "warning",
                        showCancelButton: true,
                        confirmButtonColor: "#3085d6",
                        confirmButtonText: "Ya",
                      });

                      if (result.isConfirmed) {
                        const response = await updateApprovalKunjungan({
                          idKunjungan: val._id,
                        });
                        Swal.fire({
                          title: "Sukses",
                          icon: "success",
                          timer: 2000,
                          showConfirmButton: false,
                        });
                        getAllKunjunganByLogin(dispatch, {
                          page: page + 1,
                          limit: totalPerHalaman,
                          cari: searchText,
                        });
                      }
                    }}
                  >
                    <i
                      className="fas fa-check-circle"
                      style={{ fontSize: "13px" }}
                    ></i>
                  </Button>
                </OverlayTrigger>
              )}

              {/* 3. TOMBOL EDIT FOTO */}
              {((auth.role === "client" && auth.jabatan === "korcab") ||
                auth.nopeg === "rizalrompis" ||
                auth.nopeg === "susansampangai") && (
                <OverlayTrigger
                  placement="top"
                  overlay={
                    <Tooltip id={`t-foto-${val._id}`}>Edit Foto</Tooltip>
                  }
                >
                  <Button
                    className="btn-icon d-flex align-items-center justify-content-center shadow-sm"
                    style={{
                      width: "32px",
                      height: "32px",
                      borderRadius: "8px",
                      backgroundColor: "#F0F9FF",
                      border: "1px solid #B9E6FE",
                      color: "#075985",
                    }}
                    onClick={() => handleClickEditFoto(val)}
                  >
                    <i
                      className="fas fa-image"
                      style={{ fontSize: "13px" }}
                    ></i>
                  </Button>
                </OverlayTrigger>
              )}

              {/* 4. TOMBOL REVISI */}
              {((auth.role === "client" && auth.jabatan === "korcab") ||
                auth.nopeg === "rizalrompis" ||
                auth.nopeg === "susansampangai" ||
                auth.role === "supervisor") && (
                <OverlayTrigger
                  placement="top"
                  overlay={<Tooltip id={`t-rev-${val._id}`}>Revisi</Tooltip>}
                >
                  <Button
                    className="btn-icon d-flex align-items-center justify-content-center shadow-sm"
                    disabled={isRevisiDisabled}
                    style={{
                      width: "32px",
                      height: "32px",
                      borderRadius: "8px",
                      backgroundColor: isRevisiDisabled ? "#F1F5F9" : "#FEF3C7",
                      border: isRevisiDisabled
                        ? "1px solid #E2E8F0"
                        : "1px solid #FDE68A",
                      color: isRevisiDisabled ? "#94A3B8" : "#B45309",
                      cursor: isRevisiDisabled ? "not-allowed" : "pointer",
                    }}
                    onClick={() => {
                      setModalRevisi(!modalRevisi);
                      setNamaNasabah(val.calonNasabah.namaNasabah);
                      setIdKunjungan(val._id);
                    }}
                  >
                    <i className="fas fa-edit" style={{ fontSize: "13px" }}></i>
                  </Button>
                </OverlayTrigger>
              )}
            </div>
          ),
        };
      });
      setListDataKunjungan(tmp);
    }
  }, [
    kunjungan.dataKunjungan,
    auth,
    dispatch,
    page,
    totalPerHalaman,
    searchText,
  ]);

  const handleCloseModal = () => {
    setShowUploadForm(false);
    setKeterangan("");
  };

  const AnyReactComponent = ({ text }) => (
    <div style={{ color: "red", fontWeight: "bold" }}>
      <i className="fas fa-map-marker-alt"></i> {text}
    </div>
  );

  const handleSearch = (e) => {
    setSearchText(e.target.value);
  };

  const handleClearSearch = () => {
    setSearchText("");
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      handleFilterChange();
    }
  };

  React.useEffect(() => {
    let tmp = [
      {
        value: "Batal",
        label: "Batal",
      },

      {
        value: "Tunda",
        label: "Tunda",
      },
    ];
    setListStatus(tmp);
  }, [kunjungan.dataKunjungan, page, totalPerHalaman]);

  const defaultProps = {
    center: {
      lat: 0,
      lng: 0,
    },
    zoom: 11,
  };

  const options = [
    { value: 10, label: "10" },
    { value: 50, label: "50" },
    { value: 100, label: "100" },
  ];
  const KeteranganModal = () => (
    <Modal
      show={modalKeteranganVisible}
      onHide={() => setModalKeteranganVisible(false)}
    >
      <Modal.Header closeButton></Modal.Header>
      <Modal.Title
        style={{ textAlign: "center", fontWeight: "bolder", margin: 0 }}
      >
        Keterangan Lengkap
        <hr></hr>
      </Modal.Title>
      {/* <Modal.Body>{selectedKeterangan}</Modal.Body> */}
      <Card.Body>{selectedKeterangan}</Card.Body>
      {/* <Modal.Footer>
        <Button
          variant="secondary"
          onClick={() => setModalKeteranganVisible(false)}
        >
          Tutup
        </Button>
      </Modal.Footer> */}
    </Modal>
  );

  const getHasil = (hasilNasabah) => {
    switch (hasilNasabah) {
      case "Batal":
        return {
          fontWeight: "bold",
          backgroundColor: "#F7DFE9",
          textColor: "#B0054B",
        };
      case "Pinjam":
        return {
          fontWeight: "bold",
          backgroundColor: "#E3EEF9",
          textColor: "#1569C7",
        };
      case "Perhitungan Minus":
        return {
          fontWeight: "bold",
          backgroundColor: "#F2E6FF",
          textColor: "#7F00FF",
        };
      case "-":
        return {
          fontWeight: "bold",
          textColor: "#000000",
        };
      default:
        return {};
    }
  };
  const getStatusRevisi = (revisi) => {
    switch (revisi) {
      case true:
        return {
          fontWeight: "bold",
          backgroundColor: "#FBECEC",
          textColor: "#DB5856",
        };
      case false:
        return {
          fontWeight: "bold",
          // backgroundColor: "#E6E6FF",
          // textColor: "#0000FF",
        };

      default:
        return {};
    }
  };

  const getKeputusan = (keputusan) => {
    switch (keputusan) {
      case "Tunda":
        return {
          fontWeight: "bold",
          backgroundColor: "#FFE6CC",
          textColor: "#FF7F00",
        };
      case "Batal":
        return {
          fontWeight: "bold",
          backgroundColor: "#F7DFE9",
          textColor: "#B0054B",
        };
      case "Disetujui":
        return {
          fontWeight: "bold",
          backgroundColor: "#E4F5C9",
          textColor: "#87CB16",
        };
      case "Ditolak":
        return {
          fontWeight: "bold",
          backgroundColor: "#FF0000",
          textColor: "#FFE6E6",
        };
      default:
        return {};
    }
  };

  const customStyles = {
    headRow: {
      style: {
        backgroundColor: "#F8FAFC",
        minHeight: "50px",
        borderTop: "1px solid #E2E8F0",
      },
    },
    headCells: {
      style: {
        fontWeight: "800",
        fontSize: "11px",
        color: "#475569",
        textTransform: "uppercase",
        justifyContent: "center",
      },
    },
    rows: {
      style: {
        minHeight: "70px",
        "&:hover": {
          backgroundColor: "#F1F5F9",
          cursor: "pointer",
          transition: "0.2s",
        },
      },
    },
    cells: {
      style: {
        fontSize: "12.5px",
        justifyContent: "center",
        color: "#1E293B",
      },
    },
  };

  const colKunjungan = [
    {
      name: "NO",
      width: "60px",
      center: true,
      selector: (row, index) => index + kunjungan.dataKunjungan.pagingCounter,
      style: {
        fontWeight: "bold",
        color: "#94A3B8",
        borderRight: "1px solid #F1F5F9",
      },
    },
    {
      name: "NASABAH",
      minWidth: "220px",
      cell: (row) => (
        <div className="py-2">
          <div
            className="text-dark"
            style={{ fontSize: "13px", fontWeight: "600" }}
          >
            {row.calonNasabah?.namaNasabah || "-"}
          </div>
        </div>
      ),
    },
    {
      name: "NIP",
      minWidth: "220px",
      cell: (row) => (
        <div className="py-2">
          <div className="large text-muted mt-1">
            <i className="far fa-id-card mr-1"></i>{" "}
            {row.calonNasabah.nip || "-"}
          </div>
        </div>
      ),
    },
    {
      name: "WAKTU & TEMPAT",
      minWidth: "200px",
      cell: (row) => (
        <div className="text-center">
          <div className="fw-600">
            {moment(row.tglKunjungan).format("DD MMM YYYY")}
          </div>
          <div
            className="small text-muted text-truncate"
            style={{ maxWidth: "180px", fontSize: "13px" }}
          >
            {row.cabang?.namaCabang || "-"}
          </div>
        </div>
      ),
    },
    {
      name: "INFORMASI FINANSIAL",
      minWidth: "280px", // Kita lebarkan sedikit agar muat menyamping
      cell: (row) => (
        <div className="d-flex align-items-center justify-content-center w-100 py-2">
          {/* SEKSI PLAFOND */}
          <div className="text-right pr-3 border-right" style={{ flex: 1 }}>
            <div
              className="text-muted"
              style={{
                fontSize: "10px",
                fontWeight: "700",
                textTransform: "uppercase",
              }}
            >
              Plafond
            </div>
            <div className="text-dark fw-700" style={{ fontSize: "13px" }}>
              {new Intl.NumberFormat("id-ID", {
                style: "currency",
                currency: "IDR",
                minimumFractionDigits: 0,
              }).format(row.plafond)}
            </div>
          </div>

          {/* SEKSI NETT */}
          <div className="text-left pl-3" style={{ flex: 1 }}>
            <div
              className="text-muted"
              style={{
                fontSize: "10px",
                fontWeight: "700",
                textTransform: "uppercase",
              }}
            >
              Nett
            </div>
            <div className="text-success fw-800" style={{ fontSize: "13px" }}>
              {new Intl.NumberFormat("id-ID", {
                style: "currency",
                currency: "IDR",
                minimumFractionDigits: 0,
              }).format(row.nett)}
            </div>
          </div>
        </div>
      ),
    },
    {
      name: "KEPUTUSAN & HASIL",
      minWidth: "200px",
      cell: (row) => {
        const kepStyle = getKeputusan(row.keputusan);
        const hasil =
          row.hasil === "Perhitungan minus"
            ? "Perhitungan Minus"
            : row.hasil || "-";
        const hasilStyle = getHasil(hasil);
        return (
          <div className="d-flex flex-column w-100" style={{ gap: "4px" }}>
            <span
              style={{
                backgroundColor: kepStyle.backgroundColor,
                color: kepStyle.textColor,
                fontSize: "14px",
                fontWeight: "800",
                padding: "4px",
                borderRadius: "4px",
                textAlign: "center",
              }}
            >
              {row.keputusan || "-"}
            </span>
            <span
              style={{
                backgroundColor: hasilStyle.backgroundColor,
                color: hasilStyle.textColor,
                fontSize: "14px",
                fontWeight: "800",
                padding: "4px",
                borderRadius: "4px",
                textAlign: "center",
              }}
            >
              {hasil}
            </span>
          </div>
        );
      },
    },
    {
      name: "MARKETING",
      minWidth: "200px",
      cell: (row) => (
        <div className="py-2">
          {/* Marketing: Nama lengkap, tegas */}
          <div className="fw-800 text-dark" style={{ fontSize: "13px" }}>
            {row.marketing?.nama || "-"}
          </div>
          {/* Nopeg Marketing kalau perlu (Opsional) */}
          <div className="text-muted small" style={{ fontSize: "13px" }}>
            Nopeg: {row.marketing?.nopeg || "-"}
          </div>
        </div>
      ),
    },
    {
      name: "SPV & AM",
      minWidth: "250px",
      cell: (row) => (
        <div className="d-flex flex-column justify-content-center py-2 w-100">
          {/* Baris SPV */}
          <div className="d-flex align-items-center mb-1">
            <span
              className="badge mr-2 d-flex align-items-center justify-content-center"
              style={{
                backgroundColor: "#E0F2FE",
                color: "#0369A1",
                fontSize: "10px",
                fontWeight: "800",
                width: "40px", // KUNCI: Berikan lebar tetap agar sejajar lurus
                height: "20px",
                borderRadius: "4px",
              }}
            >
              SPV
            </span>
            <span
              className="fw-700 text-dark text-truncate"
              style={{ fontSize: "13px" }}
            >
              {row.supervisor?.nama || "-"}
            </span>
          </div>

          {/* Baris AM */}
          <div className="d-flex align-items-center">
            <span
              className="badge mr-2 d-flex align-items-center justify-content-center"
              style={{
                backgroundColor: "#F1F5F9",
                color: "#475569",
                fontSize: "10px",
                fontWeight: "800",
                width: "40px", // KUNCI: Harus sama dengan lebar badge SPV
                height: "20px",
                borderRadius: "4px",
              }}
            >
              AM
            </span>
            <span
              className="fw-600 text-muted text-truncate"
              style={{ fontSize: "13px" }}
            >
              {row.areaManager?.nama || "-"}
            </span>
          </div>
        </div>
      ),
    },
    {
      name: "STATUS REVISI",
      minWidth: "160px",
      cell: (row) => {
        if (!row.statusRevisi) return <span className="text-muted">-</span>;
        const statusStyle = getStatusRevisi(row.statusRevisi);
        return (
          <div className="text-center">
            <span
              style={{
                backgroundColor: statusStyle.backgroundColor,
                color: statusStyle.textColor,
                fontSize: "10px",
                fontWeight: "800",
                padding: "5px 10px",
                borderRadius: "20px",
              }}
            >
              SEDANG DIREVISI
            </span>
            <div className="small text-danger mt-1" style={{ fontSize: "9px" }}>
              Dari: {row.revisiDari || "-"}
            </div>
          </div>
        );
      },
    },
    {
      name: "KETERANGAN",
      minWidth: "200px",
      cell: (row) => {
        const ket = row.keterangan || "-";
        return (
          <div
            className="text-muted"
            style={{
              fontSize: "11px",
              fontStyle: "italic",
              textAlign: "center",
            }}
          >
            {ket.length > 30 ? (
              <>
                {ket.substring(0, 30)}...
                <span
                  className="text-primary cursor-pointer d-block"
                  onClick={() => handleKeteranganClick(ket)}
                >
                  Lihat
                </span>
              </>
            ) : (
              ket
            )}
          </div>
        );
      },
    },
    {
      name: "AKSI",
      minWidth: "220px", // Dipersempit agar pas dengan tombol Soft UI kita
      center: true,
      cell: (row) => (
        <div className="d-flex justify-content-center">{row.action}</div>
      ),
    },
  ];

  React.useEffect(() => {
    setIsLoading(true);
    getAllKunjunganByLogin(dispatch, {
      page: page + 1,
      limit: totalPerHalaman,
      cari: searchText,
    })
      .then((response) => {
        setIsLoading(false); // Setelah selesai memuat data
      })
      .catch((error) => {
        setIsLoading(false); // Jika terjadi error
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Terjadi kesalahan saat memuat data.",
        });
      });
  }, [page, totalPerHalaman]);
  return (
    <>
      <Modal
        size="md"
        show={modalExport}
        onHide={() => setModalExport(false)}
        centered
      >
        <Modal.Header closeButton className="border-0 pb-0" />
        <Modal.Body className="px-4 pb-4">
          <div className="text-center mb-4">
            <div className="bg-light-success d-inline-block p-3 rounded-circle mb-3">
              <i className="fas fa-file-excel text-success fa-2x"></i>
            </div>
            <h4 className="fw-800 text-dark uppercase mb-0">Export Laporan</h4>
            <p className="text-muted small">
              Tentukan rentang tanggal laporan kunjungan.
            </p>
          </div>

          <Form>
            <Row>
              <Col md={12} className="mb-3">
                <label className="text-muted small fw-bold uppercase">
                  Tanggal Awal
                </label>
                <Form.Control
                  type="date"
                  className="rounded-lg border-light-blue shadow-none"
                  style={{ height: "48px" }}
                  onChange={(e) => setTglAwal(e.target.value)}
                />
              </Col>
              <Col md={12} className="mb-4">
                <label className="text-muted small fw-bold uppercase">
                  Tanggal Akhir
                </label>
                <Form.Control
                  type="date"
                  className="rounded-lg border-light-blue shadow-none"
                  style={{ height: "48px" }}
                  onChange={(e) => setTglAkhir(e.target.value)}
                />
              </Col>
            </Row>
            <Button
              className="btn-block py-3 fw-800 shadow-sm border-0"
              style={{ backgroundColor: "#15803D", borderRadius: "12px" }}
              onClick={submitExport}
            >
              GENERATE LAPORAN
            </Button>
          </Form>
        </Modal.Body>
      </Modal>

      <Modal
        size="md"
        show={modalRevisi}
        onHide={() => setModalRevisi(false)}
        centered
      >
        <Modal.Header closeButton className="border-0 pb-0" />
        <Modal.Body className="px-4 pb-4">
          <div className="text-center mb-4">
            <div className="bg-light-warning d-inline-block p-3 rounded-circle mb-3">
              <i className="fas fa-exclamation-triangle text-warning fa-2x"></i>
            </div>
            <h5 className="fw-800 text-dark mb-1">REVISI KUNJUNGAN</h5>
            <p className="text-primary font-weight-bold small uppercase">
              {namaNasabah}
            </p>
          </div>

          <Form.Group className="mb-4">
            <label className="text-muted small fw-bold uppercase mb-2">
              Instruksi Revisi / Keterangan
            </label>
            <Form.Control
              as="textarea"
              rows={5}
              placeholder="Tuliskan alasan atau instruksi revisi di sini..."
              className="rounded-lg shadow-inner border-0 bg-light p-3"
              onChange={(e) => setKeterangan(e.target.value)}
            />
          </Form.Group>

          <Button
            className="btn-block py-3 fw-800 border-0"
            style={{ backgroundColor: "#B45309", borderRadius: "12px" }}
            onClick={submitAjukanRevisiKunjungan}
          >
            AJUKAN REVISI
          </Button>
        </Modal.Body>
      </Modal>

      <Modal
        size="lg"
        show={modalEditFoto}
        onHide={() => setModalEditFoto(false)}
        centered
      >
        <Modal.Header closeButton className="border-0" />
        <Modal.Body className="px-4">
          <div className="d-flex justify-content-between align-items-center mb-4">
            <h5 className="fw-800 text-dark m-0">EDIT FOTO KUNJUNGAN</h5>
            <Button
              variant={showUploadForm ? "danger" : "primary"}
              onClick={() => setShowUploadForm(!showUploadForm)}
              style={{
                borderRadius: "10px",
                fontSize: "12px",
                fontWeight: "bold",
              }}
            >
              {showUploadForm ? "Batal Edit" : "Ganti Foto"}
            </Button>
          </div>

          {showUploadForm && (
            <div className="bg-light p-4 rounded-xl border-dashed mb-4 text-center">
              <i className="fas fa-cloud-upload-alt fa-3x text-primary mb-3"></i>
              <Form.Control
                type="file"
                accept=".png, .jpg, .jpeg"
                className="mx-auto"
                style={{ maxWidth: "300px" }}
                onChange={(e) => setKirimFotoKunjungan(e.target.files[0])}
              />
              <p className="text-muted small mt-2">
                Format: PNG, JPG, JPEG (Max 2MB)
              </p>
            </div>
          )}

          <div className="text-center p-3 border rounded-xl bg-white shadow-sm mb-4">
            <h6 className="text-muted small fw-bold uppercase mb-3">
              Pratinjau Foto Saat Ini
            </h6>
            {tampilFotoKunjungan ? (
              loadingEditFoto ? (
                <ColorRing height="80" width="80" />
              ) : (
                <img
                  src={urlPreview}
                  className="img-fluid rounded shadow-sm"
                  style={{ maxHeight: "400px" }}
                />
              )
            ) : (
              <div className="py-5">
                <img
                  src={require("assets/img/sorry.jpg").default}
                  style={{ width: "100px" }}
                />
                <p className="text-muted mt-2 small">Foto belum diunggah</p>
              </div>
            )}
          </div>
        </Modal.Body>
        <Modal.Footer className="border-0 justify-content-center pb-4">
          <Button
            className="px-5 py-2 fw-800"
            style={{
              backgroundColor: "#013E62",
              border: 0,
              borderRadius: "10px",
            }}
            onClick={submitEditFoto}
          >
            SIMPAN PERUBAHAN
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        size="xl"
        show={modalDetail}
        onHide={() => setModalDetail(false)}
        centered
      >
        <Modal.Header closeButton className="border-0" />
        <Modal.Body className="px-4 pb-4">
          <h4 className="fw-800 text-center mb-4">DETAIL LOKASI & BUKTI</h4>
          <Row>
            <Col md={6} className="mb-3">
              <div
                className="h-100 border rounded-xl overflow-hidden bg-light d-flex align-items-center justify-content-center shadow-sm"
                style={{ minHeight: "400px" }}
              >
                {buktiKunjungan ? (
                  loading ? (
                    <ColorRing />
                  ) : (
                    <img src={urlPreview} className="img-fluid" />
                  )
                ) : (
                  <div className="text-center p-4">
                    <img
                      src={require("assets/img/sorry.jpg").default}
                      style={{ width: "120px" }}
                    />
                    <p className="fw-bold text-muted mt-2">
                      Bukti Foto Tidak Ditemukan
                    </p>
                  </div>
                )}
              </div>
            </Col>
            <Col md={6} className="mb-3">
              <div
                className="h-100 border rounded-xl overflow-hidden shadow-sm"
                style={{ minHeight: "400px" }}
              >
                <GoogleMapReact
                  bootstrapURLKeys={{
                    key: "AIzaSyDEQbFkmNjBsVFEHW_pLszpxLNOXr5HLYk",
                  }}
                  center={{
                    lat: latitude || -0.4948,
                    lng: longitude || 117.1355,
                  }}
                  defaultZoom={15}
                >
                  {latitude && longitude && (
                    <AnyReactComponent lat={latitude} lng={longitude} />
                  )}
                </GoogleMapReact>
              </div>
            </Col>
          </Row>
        </Modal.Body>
      </Modal>

      {/* <Modal
        size="lg"
        show={modalDetail}
        onHide={() => setModalDetail(!modalDetail)}
        aria-labelledby="example-modal-sizes-title-lg"
      >
        <Modal.Header closeButton></Modal.Header>
        <Col md="12" style={{ marginTop: 20 }}>
          <div style={{ maxHeight: "800px", overflowY: "scroll" }}>
            <Card className="stacked-form" style={{ border: 0 }}>
              <Card.Body
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                  gap: "20px",
                }}
              >
                <div style={{ flex: 1, textAlign: "center" }}>
                  <Card.Title
                    as="h4"
                    style={{
                      color: "black",
                      fontWeight: "bold",
                      textAlign: "center",
                    }}
                  >
                    Detail Kunjungan
                    <hr />
                  </Card.Title>
                  {buktiKunjungan ? (
                    <img
                      src={
                        buktiKunjungan +
                        "?test=" +
                        new Date().getTime().toString()
                      }
                      alt="Bukti Kunjungan"
                      style={{ maxWidth: "100%", maxHeight: "50%" }}
                    />
                  ) : (
                    <>
                      <div style={{ marginBottom: "1rem" }}>
                        <div
                          style={{
                            backgroundColor: "#E0D5FA",
                            color: "#703BE7",
                            borderRadius: "8px",
                            padding: "10px 15px",
                            boxShadow: "0 3px 8px rgba(0, 1, 0, 0.3)",
                            fontWeight: "bold",
                            textAlign: "center",
                          }}
                        >
                          Maaf, masih belum ada bukti Kunjungan untuk saat ini..
                        </div>
                      </div>
                      <img
                        src={require("assets/img/sorry.jpg").default}
                        alt="Sorry"
                        style={{ maxWidth: "80%", borderRadius: "5px" }}
                      />
                    </>
                  )}
                </div>

                <div
                  style={{
                    width: "1px",
                    backgroundColor: "red",
                    height: "100%",
                  }}
                ></div>

                <div style={{ flex: 1 }}>
                  <Card.Title
                    as="h4"
                    style={{
                      color: "black",
                      fontWeight: "bold",
                      textAlign: "center",
                    }}
                  >
                    Lokasi
                    <hr />
                  </Card.Title>
                  <div
                    style={{ height: "50vh", width: "100%", margin: "auto" }}
                  >
                    <GoogleMapReact
                      bootstrapURLKeys={{
                        key: "AIzaSyDEQbFkmNjBsVFEHW_pLszpxLNOXr5HLYk",
                      }}
                      center={{
                        lat: latitude || defaultProps.center.lat,
                        lng: longitude || defaultProps.center.lng,
                      }}
                      defaultZoom={defaultProps.zoom}
                    >
                      {latitude !== null && longitude !== null && (
                        <AnyReactComponent
                          lat={latitude}
                          lng={longitude}
                          // text="My Marker"
                        />
                      )}
                    </GoogleMapReact>
                  </div>
                </div>
              </Card.Body>
            </Card>
          </div>
        </Col>
      </Modal> */}

      <Container fluid className="py-4">
        <Row>
          <Col md="12">
            <Card
              className="border-0 shadow-sm"
              style={{ borderRadius: "20px" }}
            >
              <Card.Header className="bg-white border-0 pt-4 px-4">
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <div>
                    <h3
                      className="fw-800 text-dark m-0"
                      style={{ letterSpacing: "1px" }}
                    >
                      LIST KUNJUNGAN
                    </h3>
                    <p className="text-muted small mb-0">
                      Monitor dan kelola riwayat kunjungan nasabah secara
                      real-time.
                    </p>
                  </div>
                  {/* Action Area: Export Button */}
                  <Button
                    className="btn-wd d-flex align-items-center shadow-sm border-0"
                    onClick={() => setModalExport(true)}
                    style={{
                      backgroundColor: "#DCFCE7",
                      fontWeight: "800",
                      color: "#15803D",
                      borderRadius: "12px",
                      padding: "10px 20px",
                      fontSize: "13px",
                    }}
                  >
                    EXPORT EXCEL
                    <img
                      alt="excel"
                      src={require("assets/img/excel2.png").default}
                      style={{ width: "20px", marginLeft: "10px" }}
                    />
                  </Button>
                </div>

                {/* FILTER TOOLBAR */}
                <div className="bg-light p-3 rounded-xl border-0 mt-3 shadow-inner">
                  <Row className="align-items-center g-2">
                    <Col md={4} sm={12}>
                      <InputGroup className="bg-white rounded-lg border shadow-sm">
                        <InputGroup.Prepend>
                          <InputGroup.Text className="bg-transparent border-0 text-muted">
                            <i className="fas fa-search"></i>
                          </InputGroup.Text>
                        </InputGroup.Prepend>
                        <Form.Control
                          className="border-0 bg-transparent"
                          style={{ height: "45px", boxShadow: "none" }}
                          type="text"
                          value={searchText}
                          onChange={handleSearch}
                          placeholder="Nama Nasabah / NIP..."
                          onKeyDown={handleKeyDown}
                        />
                        {searchText && (
                          <InputGroup.Append>
                            <InputGroup.Text
                              className="bg-transparent border-0 text-muted cursor-pointer"
                              onClick={handleClearSearch}
                            >
                              <i className="fas fa-times"></i>
                            </InputGroup.Text>
                          </InputGroup.Append>
                        )}
                      </InputGroup>
                    </Col>

                    <Col md="auto" sm={12} className="mt-2 mt-md-0">
                      <Button
                        variant="info"
                        className="px-4 fw-bold shadow-sm d-flex align-items-center text-white"
                        style={{
                          borderRadius: "10px",
                          height: "45px",
                          backgroundColor: "#00BFFF",
                          border: "none",
                        }}
                        onClick={handleFilterChange}
                      >
                        <i className="fas fa-filter mr-2"></i> CARI DATA
                      </Button>
                    </Col>
                  </Row>
                </div>
              </Card.Header>

              <Card.Body className="px-4 pb-4">
                {isLoading ? (
                  <div className="py-5 text-center d-flex flex-column align-items-center">
                    <Watch height="70" width="70" color="#577d86" />
                    <h5 className="mt-4 fw-600 text-muted animate-pulse">
                      Menghubungkan ke Server...
                    </h5>
                  </div>
                ) : (
                  <div className="table-responsive-custom">
                    <DataTable
                      columns={colKunjungan}
                      data={listDataKunjungan}
                      customStyles={customStyles}
                      pagination={false}
                      highlightOnHover
                      pointerOnHover
                    />

                    {modalKeteranganVisible && <KeteranganModal />}

                    {/* PAGINATION FOOTER */}
                    <div className="d-flex flex-column flex-md-row justify-content-between align-items-center mt-4 pt-4 border-top">
                      <div className="d-flex align-items-center mb-3 mb-md-0">
                        <span className="text-muted small fw-bold mr-3">
                          Tampilkan
                        </span>
                        <div style={{ width: "100px" }}>
                          <Select
                            classNamePrefix="react-select"
                            value={options.find(
                              (opt) => opt.value === totalPerHalaman,
                            )}
                            onChange={handlePageSizeChange}
                            options={options}
                            menuPlacement="top"
                          />
                        </div>
                        <span className="text-muted small ml-3 d-none d-sm-inline">
                          baris
                        </span>
                      </div>

                      <ReactPaginate
                        forcePage={page}
                        containerClassName="pagination mb-0"
                        pageClassName="page-item"
                        pageLinkClassName="page-link"
                        previousClassName="page-item"
                        previousLinkClassName="page-link"
                        nextClassName="page-item"
                        nextLinkClassName="page-link"
                        activeClassName="active"
                        disabledClassName="disabled"
                        pageCount={kunjungan.dataKunjungan.totalPages || 1}
                        nextLabel={<i className="fas fa-chevron-right"></i>}
                        previousLabel={<i className="fas fa-chevron-left"></i>}
                        onPageChange={(val) => setPage(val.selected)}
                      />
                    </div>
                  </div>
                )}
              </Card.Body>
            </Card>
          </Col>
        </Row>

        <style>{`
    .fw-800 { font-weight: 800; }
    .fw-600 { font-weight: 600; }
    .rounded-xl { border-radius: 15px !important; }
    .rounded-lg { border-radius: 10px !important; }
    .shadow-inner { box-shadow: inset 0 2px 4px 0 rgba(0,0,0,0.05); }
    
    /* Animation Pulse */
    @keyframes pulse {
      0% { opacity: 1; }
      50% { opacity: 0.5; }
      100% { opacity: 1; }
    }
    .animate-pulse { animation: pulse 2s infinite; }

    /* Custom Table Border */
    .rdt_Table { border: 1px solid #f1f5f9; border-radius: 12px; }
  `}</style>
      </Container>
    </>
  );
}

export default ListKunjungan;
